import React, { useState } from 'react'
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  Paper,
  Switch,
  Typography
} from '@mui/material'

import { Filter } from '../../../components/_WMS/FilterComponent'
import { ConfigMode } from '../types'
import { useApi } from '../../../hooks/useApi'
import { postExternalStorage } from '../config/api'
import { Status } from '../../../hooks/useFetchState'
import ServerStorageIcon from './ResourceModal/Icons'

interface StorageConfigModalProps {
  skuId: number
  sku: string
  currentValue: boolean
  setMode: React.Dispatch<React.SetStateAction<ConfigMode>>
  onClose: () => void
  handleSnackbar: (message: string, success: boolean) => void
  requestProduct: (filters?: Filter[], page?: number, pageSize?: number) => void
}

export const StorageConfigModal: React.FC<StorageConfigModalProps> = ({
  skuId,
  currentValue,
  setMode,
  onClose,
  handleSnackbar,
  requestProduct
}) => {
  const [enabled, setEnabled] = useState<boolean>(currentValue)
  const { state, callApi } = useApi()

  const handleSave = () => {
    callApi(postExternalStorage(skuId, enabled))
      .then(() => {
        handleSnackbar('Almacenamiento externo actualizado correctamente', true)
        requestProduct()
        onClose()
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant='body2' color='textSecondary'>
        Gestiona el almacenamiento externo para este producto.
      </Typography>

      <Paper
        variant='outlined'
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          borderRadius: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <ServerStorageIcon size={32} color='#1976d2' />
          <Box>
            <Typography variant='subtitle2' sx={{ fontWeight: 600 }}>
              Almacenamiento externo
            </Typography>
            <Typography variant='body2' color='textSecondary'>
              {enabled
                ? 'El almacenamiento externo está activado.'
                : 'El almacenamiento externo está desactivado.'}
            </Typography>
          </Box>
        </Box>
        <Switch
          checked={enabled}
          onChange={(e) => setEnabled(e.target.checked)}
          color='primary'
          disabled={state.status === Status.Loading}
        />
      </Paper>

      <DialogActions sx={{ p: 0, justifyContent: 'flex-end', gap: 1 }}>
        <Button
          variant='outlined'
          onClick={() => setMode('MENU')}
          disabled={state.status === Status.Loading}
        >
          Cancelar
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleSave}
          disabled={state.status === Status.Loading || enabled === currentValue}
          startIcon={
            state.status === Status.Loading ? (
              <CircularProgress size={16} color='inherit' />
            ) : undefined
          }
        >
          Aceptar
        </Button>
      </DialogActions>
    </Box>
  )
}
